import { FormsService } from "./../../../services/forms/forms.service";

import { ChangeConfirmationSettingsActionType } from "./../types";
import { getChangedFormConfirmationSettings } from "./../../../helpers/dataManipulations";

export function* changeConfirmationSettingsSaga({ payload }: ChangeConfirmationSettingsActionType) {
    try {
        yield FormsService.newUpdateForm({
            data: getChangedFormConfirmationSettings(payload.prevState, payload.currentState),
        });
    } catch (error) {
        // yield put(Handle Error);
    }
}
